// Central config for external links used across the landing page.
// При Docker-установке значения подставляются в /config.js из .env (MAX_BOT_LINK/MAX_CHANNEL_LINK)
// при старте контейнера — см. landing/docker/entrypoint.sh. Значения ниже — дефолт для локальной разработки.

const runtimeConfig = (typeof window !== "undefined" && window.APP_CONFIG) || {};

// Подставляет в ?start= метку источника трафика (utm_campaign с сайта или id кампании Директа),
// чтобы в БД бота (User.utmSource) было видно, из какой рекламной кампании пришёл человек —
// без этого весь трафик с лендинга схлопывался в один тег "landing".
function withStartTag(url) {
  if (typeof window === "undefined") return url;
  const pageParams = new URLSearchParams(window.location.search);
  const utmCampaign = pageParams.get("utm_campaign");
  const yclid = pageParams.get("yclid");
  let tag = "landing";
  if (utmCampaign) {
    tag = `landing_${utmCampaign.replace(/[^A-Za-z0-9_-]/g, "").slice(0, 40)}`;
  } else if (yclid) {
    tag = "landing_ydirect";
  }
  // yclid (id клика Яндекс.Директа) клеим отдельно через точку — при появлении офлайн-конверсий
  // (как у ТАРО) бот сможет сообщать Метрике о реальной оплате по этому клику.
  if (yclid) {
    tag = `${tag}.${yclid.replace(/[^A-Za-z0-9_-]/g, "").slice(0, 25)}`;
  }
  const parsed = new URL(url);
  parsed.searchParams.set("start", tag);
  return parsed.toString();
}

export const MAX_BOT_LINK = withStartTag(runtimeConfig.MAX_BOT_LINK || "https://max.ru/se13480529_bot?start=landing");
export const MAX_CHANNEL_LINK = runtimeConfig.MAX_CHANNEL_LINK || "https://max.ru/channel_skazkidlyadetey";
export const LULLABY_CHANNEL_LINK = runtimeConfig.LULLABY_CHANNEL_LINK || "https://max.ru/channel_otsyv";
export const API_BASE = runtimeConfig.API_BASE || "https://skazkidladetey.ru";
export const ADMIN_PANEL_LINK = "/admin";
